module.exports = __webpack_public_path__ + "img/dl.f4c5c0ab.png";